


















import Color from '@/color'
import {computed, defineComponent, PropType} from '@vue/composition-api'

interface ColorInputInlineProps {
  value: Color;
}

export default defineComponent<ColorInputInlineProps>({
  name: 'ColorInputInline',
  props: {
    value: {
      type: Object as PropType<Color>,
      required: true
    },
  },
  setup(props: ColorInputInlineProps, {emit}) {
    const handleInput = (event: Color) => {
      // Don't emit event unless value changes.
      if (props.value &&
        props.value.r === event.r &&
        props.value.g === event.g &&
        props.value.b === event.b)
        return;

      emit('input', {
        r: event.r / 255,
        g: event.g / 255,
        b: event.b / 255,
        a: 1,
      })
    }

    // TODO: Extract this to utility functions
    const value8Bit = computed(() => {
      // Rescale RGB channels to 0-255 range, but leave alpha alone
      return {
        r: 255 * props.value.r,
        g: 255 * props.value.g,
        b: 255 * props.value.b,
      }
      // NOTE: This is used to set a color picker value.
      // Alpha property is omitted in returned value, so color picker does not show alpha channel input in UI.
    })

    // TODO: Extract this to utility functions
    const colorToHex = (color: Color) => {
      return '#' +
        [color.r, color.g, color.b].map((c) => {
          const s = Math.round(c).toString(16)
          if (s.length == 1)
            return '0' + s
          else
            return s
        }).join('')
    }

    return {handleInput, value8Bit, colorToHex}
  },
})
